import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Box, Grid, Typography } from "@mui/material";
import { InitialData } from "../types";
import { Footer } from "../../../components/Footer";
import { ReportErrorLink } from "../../../components/ReportErrorLink";
import { ScanToRedeemButton } from "../styles/styles";
import { viewMoreBtnStyle, scanToRedeemButtonStyle } from "../../../components/Buttons";
import { ViewMoreBtn } from "../../multi-coupons/MultiCoupons.styles";
import GiftIcon from "../../../assets/icons/gift2.svg";
import { links } from "../../../constants/links";
import SVG from "react-inlinesvg";
import { SliderBox } from "./SliderBox";

type FooterContainerProps = {
    data: InitialData;
    used: boolean;
    isExpired: boolean;
    engageSession: string;
    isScanQr: boolean;
    onCam: () => void;
    offCam: () => void;
    onSelfRedeem: (code: string) => void;
    onSelfError?: string;
    onClearSelfError?: () => void;
};

export const FooterContainer = ({
    data,
    used,
    isExpired,
    engageSession,
    isScanQr,
    onCam,
    offCam,
    onSelfRedeem,
    onSelfError,
    onClearSelfError,
}: FooterContainerProps) => {

    const navigate = useNavigate();
    const { t } = useTranslation();

    const goToRewardList = (use?: boolean) => {
        offCam();
        navigate(links.EARN_PAGE + (use ? "?tab=1&is_reload=true" : ""), { state: { engageSession } });
    };
    if (!data.coupon_used_option) return null;
    return (
        <Box className="footerBox" style={{ paddingTop: "10px" }}>
            {
                ["COUPON_WITH_INSTRUCTIONS", "SELF_SERVICE_COUPON"].includes(data.coupon_used_option)
                    ? (
                        <>
                            { (data.coupon_used_option === "SELF_SERVICE_COUPON" && (!used && !isExpired))
                                ?
                                (<SliderBox onSubmit={onSelfRedeem} errorMessage={onSelfError} onClearError={onClearSelfError} />)
                                : null
                            }
                            <Footer />
                        </>
                    )
                    : (
                        <>
                            {
                                !used && !isExpired && !isScanQr && (
                                    <Typography
                                        sx={
                                            {
                                                marginBottom: 3,
                                                color: process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__COUPON_CAN_BE_USED_N_TIMES_TEXT_COLOR || "#000000"
                                            }
                                        }
                                        className="notice_text"
                                        fontSize={15}
                                    >
                                        <span className="notice">*</span>
                                        {t("couponBalanceMsg1") + " " + data?.remain_quantity + " " + t("couponBalanceMsg2")}
                                    </Typography>
                                )
                            }
                            {
                                !used && !isExpired
                                    ? (
                                        <ScanToRedeemButton
                                            startIcon={<SVG src={GiftIcon} />}
                                            variant="contained"
                                            onClick={!used ? onCam : undefined}
                                            style={scanToRedeemButtonStyle}
                                        >
                                            {t("scanToRedeem")}
                                        </ScanToRedeemButton>
                                    )
                                    : null
                            }
                            <Grid container mt={2}>
                                {
                                    !used && !isExpired && <Grid item xs={6}>
                                        <ViewMoreBtn
                                            onClick={() => goToRewardList(true)}
                                            fullWidth
                                            variant="contained"
                                            style={viewMoreBtnStyle}
                                        >
                                            {t("useLater")}
                                        </ViewMoreBtn>
                                    </Grid>
                                }
                                <Grid
                                    item
                                    xs={(used || isExpired) ? 12 : 6}
                                    sx={{ display: "flex", justifyContent: "center", alignItems: "center", paddingBottom: 1 }}>
                                    <ReportErrorLink />
                                </Grid>
                            </Grid>
                        </>
                    )
            }
        </Box>
    );
};
